import uuid from 'uuid'
import { ImDfmStateType } from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/constants'
import { imDfmFeedback_quoteModelRevision_dfmFeedback_topic as DfmFeedbackTopicType } from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/__generated__/imDfmFeedback'

import {
    createImDfm3dSlide,
    deleteImDfm3dSlide,
    duplicateImDfm3dSlide,
    updateImDfmSlide,
} from './actions'

export const CREATE_IM_DFM_3D_SLIDE = 'CREATE_IM_DFM_3D_SLIDE'
export const DELETE_IM_DFM_3D_SLIDE = 'DELETE_IM_DFM_3D_SLIDE'
export const DUPLICATE_IM_DFM_3D_SLIDE = 'DUPLICATE_IM_DFM_3D_SLIDE'
export const UPDATE_IM_DFM_3D_SLIDE = 'UPDATE_IM_DFM_3D_SLIDE'

export type ImDfm3dSlideValuesType = {
    qmrId: string
    topic?: string
    status?: string
    message?: string
    messageBody?: string
    title?: string
}
export type UpdateImDfm3dSlideValuesType = {
    message?: string
    messageBody?: string
    qmrId: string
    slideId: string
    status?: ImDfmStateType | null
    topic?: DfmFeedbackTopicType | null
    title?: string
}
export type DeleteImDfm3dSlideValuesType = {
    qmrId: string
    slideId: string
}
export interface UnsavedImDfm3dSlideStateType {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [x: string]: any
    slideId: string
    topic?: DfmFeedbackTopicType | null
    status?: ImDfmStateType | null
    message?: string
    messageBody?: string
    title?: string
}

export interface UnsavedSlideStateType {
    [key: string]: UnsavedImDfm3dSlideStateType[]
}

type ActionType =
    | ReturnType<typeof deleteImDfm3dSlide>
    | ReturnType<typeof createImDfm3dSlide>
    | ReturnType<typeof duplicateImDfm3dSlide>
    | ReturnType<typeof updateImDfmSlide>

const unsavedImDfm3dSlidesReducer = (
    state: UnsavedSlideStateType = {},
    action: ActionType,
) => {
    switch (action.type) {
        case CREATE_IM_DFM_3D_SLIDE: {
            const {
                qmrId,
                topic,
                title = '',
                status = '',
                message = '',
                messageBody = '',
            } = action.imDfm3dSlideValues || {}

            if (state[qmrId]) {
                return {
                    ...state,
                    [qmrId]: [
                        ...state[qmrId],
                        {
                            slideId: uuid.v4(),
                            topic,
                            status,
                            message,
                            messageBody,
                            title,
                        },
                    ],
                }
            }
            return {
                ...state,
                [qmrId]: [
                    {
                        slideId: uuid.v4(),
                        topic,
                        status,
                        message,
                        messageBody,
                        title,
                    },
                ],
            }
        }
        case DELETE_IM_DFM_3D_SLIDE: {
            const { qmrId, slideId } = action.deleteUnsaved3dDfmSlideValues

            return {
                ...state,
                [qmrId]: state[qmrId].filter(
                    (slide: UnsavedImDfm3dSlideStateType) =>
                        slide.slideId !== slideId,
                ),
            }
        }
        case DUPLICATE_IM_DFM_3D_SLIDE: {
            const {
                qmrId,
                topic,
                status,
                message = '',
                messageBody = '',
            } = action.duplicateImDfm3dSlideValues || {}

            if (state[qmrId]) {
                const duplicatedSlide = {
                    slideId: uuid.v4(),
                    topic,
                    status,
                    message,
                    messageBody,
                } as UnsavedImDfm3dSlideStateType

                const index = state[qmrId].findIndex(
                    slide => slide.topic === duplicatedSlide.topic,
                )

                state[qmrId].splice(index, 0, duplicatedSlide)
            }

            return {
                ...state,
                [qmrId]: [...state[qmrId]],
            }
        }
        case UPDATE_IM_DFM_3D_SLIDE: {
            const { qmrId, slideId, topic, status, message, messageBody } =
                action.updateImDfm3dSlideValues || {}

            const index = state[qmrId].findIndex(slide => {
                return slide.slideId === slideId
            })

            const updatedArray = [...state[qmrId]]

            updatedArray[index].status = status
            updatedArray[index].topic = topic
            updatedArray[index].message = message
            updatedArray[index].messageBody = messageBody

            return {
                ...state,
                [qmrId]: updatedArray,
            }
        }
        default:
            return state
    }
}

export default unsavedImDfm3dSlidesReducer
